<template>
    <b-card
        :class="[isDark ? 'bg-primary' : '', noButton ? 'cursor-pointer' : '']"
        class="shadowed h-100"
        @click="noButton ? $emit('cta') : null"
    >
        <div class="d-flex">
            <miu-icon :icon="icon" />

            <div class="pl-3">
                <p class="text-overline text-uppercase mb-2" :class="overlineClass">
                    {{overline}}
                </p>
                <h6 class="mb-0" :class="titleClass">{{ title }}</h6>
            </div>
        </div>
        <div class="d-flex justify-content-end align-items-end mt-4">
            <div class="d-flex align-items-center">
                <b-button
                    v-if="!isLocked && !noButton"
                    :variant="isCompleted ? 'outline-secondary' : 'secondary'"
                    @click="!noButton ? $emit('cta') : null"
                >
                    {{ctaText}}
                </b-button>
                <b-icon
                    v-if="isCompleted"
                    icon="check-circle-fill"
                    variant="success"
                    font-scale="1.5"
                    class="ml-3"
                />
            </div>
        </div>
    </b-card>
</template>

<script>
import MiuIcon from "../../atoms/MiuIcon";
export default {
    name: "MiuCard",
    components:{MiuIcon},
    props:{
        isDark: Boolean,
        isLocked: Boolean,
        isCompleted: Boolean,
        overline: String,
        title: String,
        icon: String,
        ctaText: String,
        noButton: Boolean
    },
    computed:{
        overlineClass: function (){
            let overline = '';

            if(this.isLocked){
                overline = 'text-muted'
            }

            if(this.isDark){
                overline = 'text-white'
            }

            return overline;
        },
        titleClass: function (){
            let title = 'text-primary';

            if(this.isLocked){
                title = 'text-muted'
            }

            if(this.isDark){
                title = 'text-white'
            }

            return title;
        },
    }
}
</script>

<style scoped>
.cursor-pointer{
    cursor: pointer;
}
</style>